import { ClockingLocationQRCodeLinks } from "src/widgetLink";
import { UserAccessTypeRef } from "../../models/auth/user-access-type";
import { NIL } from "uuid";

//#region access type
export const ACCESS_TYPES: Record<string, UserAccessTypeRef> = {
  NO_ACCESS: {
    id: "361e0064-fb35-4079-acf9-f5969f774e6b",
    name: "No access",
    isDeleted: false,
    isConstant: true,
  },
  VIEW_ALL: {
    id: "134b540b-8f3a-498c-ace3-a758abec7dec",
    name: "View All",
    isDeleted: false,
    isConstant: true,
  },
  CHANGE_ALL: {
    id: "a4e64a9d-7e0d-49fe-bd04-02ee4be67fbd",
    name: "Change All",
    isDeleted: false,
    isConstant: true,
  },
  VIEW_SOME: {
    id: "7e7d5503-906c-45a3-88ac-d162b6234a1e",
    name: "View Some",
    isDeleted: false,
    isConstant: true,
  },
  CHANGE_SOME: {
    id: "427f07ca-270b-44c7-939f-2fc00958b619",
    name: "Change Some",
    isDeleted: false,
    isConstant: true,
  },
};
//#endregion access type

//#region Authorizations
export const AUTHORIZATIONS = {
  NoAccess: NIL,

  UserIsEmployee: "2614ade2-42bd-4032-b07d-4628791d56a6",
  UserIsClient: "3762d095-ead5-4ac6-b8aa-5b6f03096128",
  UserIsALReviewer: "a89ffbaf-2baa-41f0-bb82-1c0b1f65df49",
  UserIsAlToConfigureAdvertisementPopups: "0eec054b-540b-47f7-9ce4-c7b27b6bb909",
  UserIsAllowedToGenerateTnALocationQR: "66bbea5b-5322-470e-bad7-4049adf51c79",

  SystemAccess: {
    ManageUserAdminAccess: "399f0fba-4c2c-4aad-9222-581df1e7264d",
    SystemConfig: "F7BF5AB1-9C82-4CBB-954F-6B246A1112F9",
    ServiceProvidersConfig: "5CC740CF-5E53-4811-921A-FDF99A838B87",
    CompanyAccountsConfig: "1d53eabf-1b33-4050-bf13-d30a3f948065",
    AccessToAllClientDataId: "b87a6e50-0dc9-4c90-bc04-de8f0e9d16fb",
    CalendarsConfig: "dfec31f2-e3ee-471a-b926-1103d45f5bee",
    MaintainTnASchedules: "6b027ee1-5c03-419b-a918-e909a06d9c13",
    MaintainTnACalendars: "ce37770a-9757-4fbd-98a1-a2c7cd145ff9",
    MaintainWageTypes: "cedaecd2-baeb-4043-bfb2-749ffa70009d",
    MaintainCostSimulationRules: "c10fc3b2-c268-4966-aaf7-ee5abaa80640",
  },

  ServiceProvidersAccess: {
    ManageUserAccessToServiceProvider: "60bb3ff7-ca84-4323-a126-a9dd9c3a3391",
    ServiceProvidersConfiguration: "ea619425-8bb4-4d33-8832-717fccd4d71c",
  },

  CompanyAccountsAccess: {
    CompanyAccountConfig: "e3c982a7-f6c0-47ea-9478-5b28f573bf1d",
    LegalEntityAdminAccess: "05ca148e-32ce-4770-a757-d8fa417e2ced",
    EmployeeGroupConfig: "3a092304-9cd8-4412-bb0d-cc44d59e9fcc",
    CanProcessDocumentNotLinkedToLe: "eead615f-edf0-4fd6-a033-c13658caf377",
    ManageUserAdminAccessToCompanyAccounts: "0b327406-8a00-4152-8fd0-f26dbed3ef1e",
    ManageUserAccessToEeGroups: "9e8e53e0-9e8a-45c0-ae2d-b6fe6c7fba2d",
    ManagePolicies: "02dd5477-b63b-4d41-ba9f-fe8b9a889436",
  },

  RecruitingAccess: {
    CanOpenPositionsAndAddCreateCandidates: "b54d20eb-b1d7-4800-9fa0-9d18657038a4",
    CanCreateRecruiters: "28a38fb1-470f-43d5-84d1-d3acf4ff1a62",
    CanAddHiringClients: "b089b2e0-2898-424e-a4c8-ba97983d564e",
    CanProvideUserAccess: "0e749c11-283a-425d-9af4-4b6808f65201",
    AccessAllHiringClients: "5e821a8f-5765-4590-88f2-88c238973560",
  },

  LegalEntityAccess: {
    ManageUserAdminAccess_ToLegalEntities: "110af12c-f4ae-41bf-ad22-742874be6acc",
    LegalEntityConfig: "119cc43d-529c-42c9-ab5c-1adacd808798",
    UploadDocuments: "5e803a64-79e7-464d-b1f9-8bad2031ab73",
    DownloadDocuments: "2a7880ba-6716-43ef-afb0-f01eabc6c07a",
    ProcessIncomingDocuments: "3c04a476-8ca6-4c1b-a466-ece7bcb8f50c",
    ProcessAccounting: "d25bada2-2bff-4486-8456-a730cfb10fc7",
    RunAccountingReports: "8669d0c3-cae9-4ad4-be5c-bb28ce16c074",
    ViewAccountingOutput: "bfa51704-2b07-453d-ba94-da44b623a576",
    ViewPayrollOutput: "6d605b48-ab9f-459b-940f-b5f82acddf9d",
    ProcessPayroll: "e4ef233c-d843-47a1-9856-d45966d2c377",
    ViewComplianceData: "9c59fdd7-0b1e-41a6-ac97-285245e89c78",
    ViewActivityData: "8e5ba2ad-765f-4625-9728-97c05ecc1a04",
    ManagePolicies: "81c9a2f1-fe5c-4923-a286-0b88352ef009",
    ManageLegalEntitySI: "b172e01d-c963-4055-95d1-8c11f397cdf7",
    ViewLegalEntitySI: "4f0c2581-6d23-4a2c-acfa-153a140d934a",
    ViewAccountManagement: "f75275a3-2b25-47d9-94cb-9126d02eae4d",
    AuthorizeArchiveDownload: "1117a10d-2bad-4827-a4cb-3d9e5ecf785b",
    RunSurvey: "f0ac3669-bd58-429e-9610-59a23a4053a6",
  },

  EmployeesAccess: {
    // through EE groups
    ConfigureEmployeeGroupParameters: "69f06103-7a4d-41c4-a975-1abbfd0e3ef8",
    CreateEmployees: "51a53b17-5897-4e5b-8d24-55311eb2b7fe",
    ViewNonSalaryAndCompensationData: "1f4f17a2-57fe-4e9a-82c7-6c8f5cf9a924",
    ApproveTimeAndLeaves: "6f973d43-d8fd-40a7-8dc0-d0a9626e6812",
    ApproveExpenses: "a7c2913b-2936-42a3-b27c-e62f5ee28f47",
    PayExpenses: "5a144445-a3af-49a3-a9a7-6dbed4b9787d",
    ChangeEmploymentData: "a0389aa2-8408-400b-b4ac-19edf1d0c34e", //previously called EnterEmploymentMutations
    ViewSalaryAndCompensationData: "ffc3a5b8-feb4-47b1-bd4e-cb940bfc21db",
    CreateAndManageClientMissions: "0bcb0686-06f2-4229-803e-af3d3f8aada5",
    EnterClientApprovals: "bc22518b-6083-4da3-aeac-cebe9fb1763d",
    GiveEmployeesAccessToTheirOwnEmploymentData: "6b8efbf8-fc4b-4e26-8544-fb25aaf3b38e",
    GiveUsersAccessToThisEmployeeGroup: "b96626be-971a-4916-8da3-06727d8f8ae5",
    AuditTravelAndExpenses: "81c9a2f1-fe5c-4923-a277-0b88352ef119",
    ApproveNonAuditedExpenses: "81c9a2a1-ae5c-4223-a527-0b88352ef119",
    ProvidePayrollInput: "cd95cb1d-4cd3-46c0-92ed-3aadcfcf2008",
    ViewRelatedComplianceData: "a5ea98a8-d309-4cea-8d21-8dec80ef46db",
    ViewPolicies: "38ec0c2c-9667-4e4e-912b-65ecc3f12fb6",
    RunSurvey: "056f9e97-bd0b-4781-a6cb-442f02e39afa",
    ManagePolicies: "98f8ecd9-b6f8-4250-b193-8f4817c1b940",
  },

  MailInboxAccess: {
    CanUploadIncoming: "1d30e2d1-7372-4865-b35b-72948c66ee1b",
    CanUploadOutgoing: "5feae210-edfc-4e14-a27f-44e0814e9076",
    CanClassifyIncoming: "1284d22b-dcc9-4609-af70-ad767b01bde7",
    CanClassifyOutgoing: "d446249f-b928-4748-9ca9-02892bd819c4",
    CanReadIncoming: "2de20165-c5f0-49bd-8ac9-2315351c7750",
    CanReadOutgoing: "c53e58e2-32c9-4cad-8eae-01fdfc00ea20",
    CanProcessOutgoing: "e45a8c17-77d7-41c5-974e-6bd9474ce5ee",
    isRecipient: "ef19a3a8-96e3-4e96-9387-ee9741df56d8",
  },
};
// #endregion Authorizations

export const OVERRIDABLE_LINKS_PER_ROLE = {
  [AUTHORIZATIONS.UserIsClient]: [
    "5bd48729-65f3-404e-836a-5fe0d2746a62", //MyTeamProjectAssignmentLinks.Overview
    "af7ff14f-c29e-4101-aee3-0207146f8e21", //MyTeamProjectAssignmentLinks.PendingApprovals
    "4e1fb1a0-4bfb-4927-9c76-5c4080459af6", //MyClientTeamPresenceAndLeavesLinks.MyClientTeamPresenceAndLeaves
  ],
  [AUTHORIZATIONS.UserIsALReviewer]: [
    "6d47e974-fc79-4ad8-a404-ef44a37a28dc", //ManageAlertLines
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming]: [
    "4cccc720-aa8f-491c-90d8-f2e84d47f01f", //ManageMailLinks.incoming_mail
    "09405264-fe51-4164-825b-eb29c10b0a5f", //ManageMailLinks.unclassified_incoming
    "08bfdb8a-0503-4c63-a11f-308bb4c88194", //ManageMailLinks.NoPendingMailIncomingLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing]: [
    "7d3c4be6-0a80-4d4b-b73d-107a1838f721", //ManageMailLinks.letter_addressees
    "0e85759c-c2a4-4e84-82da-4e23b4d5c6c9", //ManageMailLinks.NoPendingMailOutgoingLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanReadIncoming]: [
    "4cccc720-aa8f-491c-90d8-f2e84d47f01f", //ManageMailLinks.incoming_mail
    "08bfdb8a-0503-4c63-a11f-308bb4c88194", //ManageMailLinks.NoPendingMailIncomingLink
    "f06a2f2c-a360-4a39-b402-9c8805bf7061", //ManageMailLinks.ReadableIncomingMailLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming]: [
    "4cccc720-aa8f-491c-90d8-f2e84d47f01f", //ManageMailLinks.incoming_mail
    "08bfdb8a-0503-4c63-a11f-308bb4c88194", //ManageMailLinks.NoPendingMailIncomingLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing]: [
    "456de670-e588-4d6f-bf21-20202634a6b7", //ManageMailLinks.outgoing_mail
    "5108e869-8a39-4e96-b609-08eab224076d", // ManageMailLinks.unclassified_outgoing
    "0e85759c-c2a4-4e84-82da-4e23b4d5c6c9", //ManageMailLinks.NoPendingMailOutgoingLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing]: [
    "456de670-e588-4d6f-bf21-20202634a6b7", //ManageMailLinks.outgoing_mail
    "0e85759c-c2a4-4e84-82da-4e23b4d5c6c9", //ManageMailLinks.NoPendingMailOutgoingLink
    "d4005150-d99e-4fac-b955-267e595a320e", //ManageMailLinks.ReadableOutgoingMailLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing]: [
    "456de670-e588-4d6f-bf21-20202634a6b7", //ManageMailLinks.outgoing_mail
    "7d3c4be6-0a80-4d4b-b73d-107a1838f721", //ManageMailLinks.letter_addressees
    "0e85759c-c2a4-4e84-82da-4e23b4d5c6c9", //ManageMailLinks.NoPendingMailOutgoingLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing]: [
    "456de670-e588-4d6f-bf21-20202634a6b7", //ManageMailLinks.outgoing_mail
    "0e85759c-c2a4-4e84-82da-4e23b4d5c6c9", //ManageMailLinks.NoPendingMailOutgoingLink
    "e0e78c80-9a6f-423f-aa86-975bc1720731", //ManageMailLinks.UnprocessedOutgoingMailLink
  ],
  [AUTHORIZATIONS.MailInboxAccess.isRecipient]: [
    "9eaa4c86-2b48-4fab-a378-0ae6b883a662", //ManageMailLinks.IncomingMailForRecipientLink
  ],
  [AUTHORIZATIONS.UserIsAlToConfigureAdvertisementPopups]: [
    "6f04879e-e427-420b-b649-0fa6a5c01a20", //HelpAndTipsLinks.OpenProviderPopupsLink + RanOutOfPopups
  ],
  [AUTHORIZATIONS.UserIsAllowedToGenerateTnALocationQR]: [
    "d2c74fac-740b-4345-b539-bc552fd758c3", //ClockingLocationQRCodeLinks.GenerateCode
  ],
};
